var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex-1 px-3 py-5 sm:px-12 sm:py-8 font-outfit" },
    [
      _vm._m(0),
      _c("div", { staticClass: "flex flex-col gap-4 sm:gap-5" }, [
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Family Support")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [_vm._v(_vm._s(_vm.data.family_support || "N/A"))]
          ),
        ]),
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Access Number")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [_vm._v(_vm._s(_vm.data.social_connections || "N/A"))]
          ),
        ]),
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Community Services")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [_vm._v(_vm._s(_vm.data.community_resources || "N/A"))]
          ),
        ]),
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _vm._m(1),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [_vm._v(_vm._s(_vm.data.professional_care_contacts || "N/A"))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass:
          "justify-between items-center mb-4 pb-4 borderMainClientProfile hidden sm:flex",
      },
      [
        _c("h2", { staticClass: "text-lg font-normal" }, [
          _vm._v("Support Network"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent" },
      [
        _vm._v("Professional Care Contacts "),
        _c("span", { staticClass: "text-gray-400" }, [
          _vm._v("(Current Physiotherapist, Physician)"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }